import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (!sid) { navigate("/admin/login"); return; }
      try {
        const u = await exchangeSession(sid);
        setUser(u);
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { state: { user: u } });
      } catch {
        navigate("/admin/login");
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="adm-splash" data-testid="auth-callback">
      <div className="adm-spinner" />
      <p>Signing you in…</p>
    </div>
  );
}
